import {Button} from '@material-ui/core';
import {MoodBad} from '@material-ui/icons';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';

import {pushRoute} from '../../routes';
import DetachedIcon from '../../shared/components/detachedIcon';
import Screen from './screen';

const NotFound: React.FC = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const goToHome = () => {
    dispatch(pushRoute('welcome'));
  };

  return (
    <Screen isPageAuth={true} hideToolbar={true}>
      <DetachedIcon size="lg" icon={<MoodBad />} />
      <h2>404</h2>
      <h2 className="primary-title text-center">
        {t('nao-encontrada.pagina-nao-encontrada')}
      </h2>
      <p className="default-subtitle mt-0  text-center">
        {t('nao-encontrada.mensagem')}
      </p>
      <br /> <br />
      <Button
        className={`button-default  full-width`}
        type="button"
        variant="contained"
        color="primary"
        onClick={goToHome}
      >
        {t('nao-encontrada.inicio')}
      </Button>
    </Screen>
  );
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/features/election/NotFound.tsx